"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[82041],{

/***/ 110413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LazyComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



function LazyComponent(param) {
    let { children , timeToRender =0  } = param;
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const { 0: hydrated , 1: setHydrated  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isBot ? true : false);
    react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect(()=>{
        if (isBot || !ref.current) return;
        const ob = new IntersectionObserver((entries, observer)=>{
            for (const entry of entries){
                if (entry.isIntersecting) {
                    setHydrated(true);
                    observer.disconnect();
                    return;
                }
            }
        });
        ob.observe(ref.current);
        function hydrate(deadline) {
            if (deadline.timeRemaining() > timeToRender) {
                setHydrated(true);
                ob.disconnect();
            } else {
                requestIdleCallback(hydrate);
            }
        }
        if (timeToRender > 0) {
            requestIdleCallback(hydrate);
        }
        return ()=>ob.disconnect();
    }, [
        isBot,
        timeToRender
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: "lazy-component",
        children: hydrated ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "fake-body",
            style: {
                width: "100%",
                height: 200
            }
        })
    });
}


/***/ }),

/***/ 746882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useProductsWrapper; },
/* harmony export */   "X": function() { return /* binding */ useProductsWrapperInfinite; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(983546);
/* harmony import */ var _teko_discovery_v2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(232771);
/* harmony import */ var _teko_discovery_v2__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14643);
/* harmony import */ var components_WishlistButton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(288257);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(927890);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(534090);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39486);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(725965);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(681889);
/* harmony import */ var hooks_useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(725530);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









const useProductsWrapper = function(slug, fallbackData, isEnableHamperPage) {
    let pageSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 20;
    const { isDisplayUom , contactLink , isAllowATCFromListing , showNewProductGift , epicOmni1524 , epicOmni1821 ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { discoveryServiceV2 , discoveryHelper  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useServices */ .Su)();
    const { frames  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useFrame */ .x)();
    const cartV2 = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useCartV2 */ .T6)();
    const buildPCV2 = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useBuildPCV2 */ .s)();
    const { isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { transformProductWhenUserUnder18  } = (0,hooks_useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_8__/* .useHandlerUnderEighteenYearOld */ .x)();
    const { loading: authLoading  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_9__/* .useAuth */ .aC)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const relatedProductHook = (0,contexts__WEBPACK_IMPORTED_MODULE_10__/* .useRelatedProduct */ .I)();
    const isEnableNewBuildPCPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return router.pathname.includes("/buildpc") && !!epicOmni1524;
    }, [
        router.pathname,
        epicOmni1524
    ]);
    const discoveryCleanUpConfig = {
        showUom: isDisplayUom,
        contactLink,
        showCtaButton: isAllowATCFromListing,
        cartV2,
        buildPCV2,
        frames,
        showNewProductGift,
        showCtaButtons: isAllowATCFromListing && isEnableNewBuildPCPage || epicOmni1821,
        showCtaButtonsWithQuantity: isEnableNewBuildPCPage,
        showCtaButtonsRelevantProducts: epicOmni1821,
        isMobile,
        relatedProductHook
    };
    const _ref = (0,_teko_discovery_v2__WEBPACK_IMPORTED_MODULE_11__/* .useDiscoverySearchV2 */ .t)(discoveryServiceV2, {
        slug: slug,
        pageSize: pageSize,
        isReturnProductsBOMSkus: isEnableNewBuildPCPage || !!isEnableHamperPage
    }, {
        fallbackData: fallbackData,
        transform: (data)=>{
            var ref;
            return {
                products: (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, _objectSpread({}, discoveryCleanUpConfig)))
            };
        }
    }), { result  } = _ref, rest = _objectWithoutProperties(_ref, [
        "result"
    ]);
    const productList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return ((result === null || result === void 0 ? void 0 : result.products) || []).map((p)=>(0,helpers__WEBPACK_IMPORTED_MODULE_12__/* .createHandleEventAndCtaButton */ .D3)(p, _objectSpreadProps(_objectSpread({}, discoveryCleanUpConfig), {
                wishlistButton: {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WishlistButton__WEBPACK_IMPORTED_MODULE_13__/* .WishlistButton */ .s, {
                        sku: p.sku
                    })
                }
            }))).map(transformProductWhenUserUnder18);
    }, [
        JSON.stringify(result),
        JSON.stringify(cartV2.flattenItems),
        authLoading, 
    ]);
    return _objectSpread({
        products: productList
    }, rest);
};
const useProductsWrapperInfinite = (slug, config)=>{
    var ref, ref1, ref2;
    const { contactLink , isDisplayUom , isAllowATCFromListing , showNewProductGift , epicOmni1524 , epicOmni1821 ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { frames  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useFrame */ .x)();
    const cartV2 = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useCartV2 */ .T6)();
    const buildPCV2 = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useBuildPCV2 */ .s)();
    const { isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { discoveryServiceV2 , discoveryHelper  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useServices */ .Su)();
    const { transformProductWhenUserUnder18  } = (0,hooks_useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_8__/* .useHandlerUnderEighteenYearOld */ .x)();
    const { loading: authLoading  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_9__/* .useAuth */ .aC)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const relatedProductHook = (0,contexts__WEBPACK_IMPORTED_MODULE_10__/* .useRelatedProduct */ .I)();
    const isEnableNewBuildPCPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return router.pathname.includes("/buildpc") && !!epicOmni1524;
    }, [
        router.pathname,
        epicOmni1524
    ]);
    const discoveryCleanUpConfig = {
        showUom: isDisplayUom,
        contactLink,
        showCtaButton: isAllowATCFromListing,
        cartV2,
        buildPCV2,
        frames,
        showNewProductGift,
        showCtaButtons: isAllowATCFromListing && isEnableNewBuildPCPage || epicOmni1821,
        showCtaButtonsWithQuantity: isEnableNewBuildPCPage,
        showCtaButtonsRelevantProducts: !!epicOmni1821,
        isMobile,
        relatedProductHook
    };
    const { data , loading , loadmore , hasMore , error , isEmpty , size  } = (0,_teko_discovery_v2__WEBPACK_IMPORTED_MODULE_14__/* .useInfiniteDiscoverySearchV2 */ .x)(discoveryServiceV2, {
        slug: slug,
        pageSize: config.limit,
        isReturnProductsBOMSkus: isEnableNewBuildPCPage
    }, {
        transform: (data)=>{
            var ref;
            return {
                products: (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, _objectSpread({}, discoveryCleanUpConfig))),
                total: data.total
            };
        },
        fallbackData: [
            {
                products: (ref = config.initialValue) === null || ref === void 0 ? void 0 : ref.products,
                total: ((ref1 = config.initialValue) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pagination) === null || ref2 === void 0 ? void 0 : ref2.totalItems) || 0
            }, 
        ]
    });
    const products = data === null || data === void 0 ? void 0 : data.reduce((pageData, d)=>[
            ...pageData,
            ...d.products || []
        ], []);
    const productList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return (products || []).map((p)=>(0,helpers__WEBPACK_IMPORTED_MODULE_12__/* .createHandleEventAndCtaButton */ .D3)(p, _objectSpreadProps(_objectSpread({}, discoveryCleanUpConfig), {
                wishlistButton: {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WishlistButton__WEBPACK_IMPORTED_MODULE_13__/* .WishlistButton */ .s, {
                        sku: p.sku
                    })
                }
            }))).map(transformProductWhenUserUnder18);
    }, [
        JSON.stringify(products),
        JSON.stringify(cartV2.flattenItems),
        authLoading, 
    ]);
    return [
        {
            products: productList,
            loading,
            hasMore,
            error,
            size,
            isEmpty
        },
        {
            onNextPage: loadmore
        }, 
    ];
};


/***/ }),

/***/ 82041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LazyNewLayoutProductCarouselSlot": function() { return /* binding */ LazyNewLayoutProductCarouselSlot; },
/* harmony export */   "LazyProductCarouselSlot": function() { return /* binding */ LazyProductCarouselSlot; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(414562);
/* harmony import */ var components_LazyComponent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(110413);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(788813);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _hooks_usePbProducts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(746882);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  .horizontal-slider,\n  .glide__track {\n    background-color: white;\n    border-radius: 12px;\n  }\n  .glide__arrow--left {\n    left: 1px !important;\n    border-radius: 100px;\n    background-color: #fff !important;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n    &:after {\n      height: 24px !important;\n      width: 24px !important;\n    }\n  }\n  .glide__arrow--right {\n    right: 2px !important;\n    border-radius: 100px;\n    background-color: #fff !important;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n    &:after {\n      height: 24px !important;\n      width: 24px !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const DEFAULT_MAX_WIDTH = 1232;
var ScreenSize;
(function(ScreenSize) {
    ScreenSize[ScreenSize["s"] = 1296] = "s";
    ScreenSize[ScreenSize["m"] = 1440] = "m";
    ScreenSize[ScreenSize["l"] = 1680] = "l";
})(ScreenSize || (ScreenSize = {}));
const ProductCarouselSlot = (param)=>{
    let { collectionSlug , serverData , config ={}  } = param;
    const { isMobile  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { products  } = (0,_hooks_usePbProducts__WEBPACK_IMPORTED_MODULE_3__/* .useProductsWrapper */ .I)(collectionSlug !== null && collectionSlug !== void 0 ? collectionSlug : "", serverData);
    return (products === null || products === void 0 ? void 0 : products.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .ProductCarousel */ .G, {
        products: products,
        productsPerRow: isMobile ? 2.3 : 5,
        border: config === null || config === void 0 ? void 0 : config.borderProductCard,
        regionName: config === null || config === void 0 ? void 0 : config.regionName
    }) : null;
};
const LazyProductCarouselSlot = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_LazyComponent__WEBPACK_IMPORTED_MODULE_5__/* .LazyComponent */ .c, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCarouselSlot, _objectSpread({}, props))
    });
};
const NewLayoutProductCarouselSlot = (param)=>{
    let { collectionSlug , serverData , config ={}  } = param;
    const { isMobile  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { products  } = (0,_hooks_usePbProducts__WEBPACK_IMPORTED_MODULE_3__/* .useProductsWrapper */ .I)(collectionSlug !== null && collectionSlug !== void 0 ? collectionSlug : "", serverData);
    const productsPerRow = isMobile ? 2.3 : Number(config === null || config === void 0 ? void 0 : config.maxWidth) <= DEFAULT_MAX_WIDTH || !(0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)() ? 5 : window.innerWidth >= ScreenSize.l ? 6.5 : window.innerWidth >= ScreenSize.m ? 5.5 : window.innerWidth >= ScreenSize.s ? 5 : 4.5;
    return (products === null || products === void 0 ? void 0 : products.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .ProductCarousel */ .G, {
            products: products,
            productsPerRow: productsPerRow,
            border: config === null || config === void 0 ? void 0 : config.borderProductCard,
            regionName: config === null || config === void 0 ? void 0 : config.regionName,
            desktopProps: {
                perSwipe: "",
                bound: true
            }
        })
    }) : null;
};
const LazyNewLayoutProductCarouselSlot = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_LazyComponent__WEBPACK_IMPORTED_MODULE_5__/* .LazyComponent */ .c, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewLayoutProductCarouselSlot, _objectSpread({}, props))
    });
};
const Wrapper = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)(_templateObject());


/***/ })

}]);